import {getGlobalPerformanceNow} from './globalScopeUtils';
import {isNullish} from './Utils';

/**
 * Returns the current timestamp in milliseconds using the `performance.now()` method if available
 * to ensure monotonic timestamps; otherwise, it falls back to using `Date.now()`.
 *
 * Date.now() is dependent on the system clock and not monotonic, it may have been impacted by system
 * and user clock adjustments. The performance.now() method is relative to the timeOrigin property
 * which is a monotonic clock: its current time never decreases and isn't subject to adjustments.
 */
export function getCurrentMonotonicTimestampInMs(): number {
  const performanceNow = getGlobalPerformanceNow();
  if (isNullish(performanceNow)) {
    return Date.now();
  }

  // floor to return integer value (not double as performance.now() returns)
  return Math.floor(performanceNow);
}

export function getMonotonicTimestampInMsSince(timestampInMs: number | undefined): number | undefined {
  if (isNullish(timestampInMs)) {
    return undefined;
  }

  return getCurrentMonotonicTimestampInMs() - timestampInMs;
}
